// biome-ignore lint/style/useFilenamingConvention: TanStack Router uses $param convention for dynamic routes
import { createRoute } from '@tanstack/react-router';
import { AccessGuard } from '@/components/guards/access-guard';
import { AuthGuard } from '@/components/guards/auth-guard';
import { LotSizingPage } from '@/pages/lot-sizings/lot-sizing-page';
import { Route as RootRoute } from './__root';

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: 'lot-sizing/$id',
  component: () => (
    <AuthGuard>
      <AccessGuard>
        <LotSizingPage />
      </AccessGuard>
    </AuthGuard>
  ),
  staticData: {
    titleKey: 'LotSizing',
  },
});
